module.exports = __webpack_public_path__ + "21667630746dc13c10b9aeca98d2b96d.png";